/**
 * Phase 14.7 — the one moment where unsynced work genuinely needs the driver's
 * attention: signing out. Signing out can drop the session the durable queues
 * need, so we ask first. Observation only — no queue mutation, no upload logic.
 */
import { syncQueue } from "@/lib/offlineDb";
import { getPendingUploadCount } from "@/lib/appraisalUploadQueue";

export async function countUnsyncedWork(): Promise<number> {
  const [items, photos] = await Promise.all([
    syncQueue.getAll().catch(() => [] as unknown[]),
    getPendingUploadCount().catch(() => 0),
  ]);
  return items.length + photos;
}

/**
 * Returns true when it is safe to continue signing out.
 * Silent when everything is already uploaded.
 */
export async function confirmSignOutWithUnsyncedWork(): Promise<boolean> {
  const outstanding = await countUnsyncedWork();
  if (outstanding === 0) return true;
  if (typeof window === "undefined") return true;
  return window.confirm(
    "Some of today’s work hasn’t finished uploading yet.\n\n" +
      "It is stored safely on this device and will upload automatically once you're back online. " +
      "Signing out now may delay it.\n\nSign out anyway?"
  );
}
